import React from 'react';
import numberFormatter from 'number-formatter';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import moment from 'moment';
import Immutable from 'seamless-immutable';
import * as invoiceActions from '../../actions/invoice';
import LoadingScreen from '../LoadingScreen';
import PageHeader from '../boxes/PageHeader';
import PageBody from '../boxes/PageBody';
import MainContent from '../boxes/MainContent';
import NotificationBanner from '../boxes/NotificationBanner';
import PoliciesAwarenessBanner from '../boxes/PoliciesAwarenessBanner';
import {
    getDaysToCoverEnd,
    getPaymentFrequency,
    getCoverWarningType
} from '../InvoiceDetailsComponent';
import { withTranslation } from 'react-i18next';
import { appConfig } from '../../config/appConfig';

class InvoiceListComponent extends React.Component {
    componentDidMount() {
        const { dispatch, user } = this.props;
        dispatch(
            invoiceActions.getClientInvoices(user.credentials.accessToken, user.companyInfo.id)
        );
    }

    renderLoading() {
        return (
            <MainContent>
                <PageBody>
                    <LoadingScreen />
                </PageBody>
            </MainContent>
        );
    }

    render() {
        const { isFetching, invoices, user, t } = this.props;
        const selectedInvoice = invoices.length > 0 ? invoices[0] : {};
        const daysToCoverEnd = getDaysToCoverEnd(selectedInvoice.end_date);

        if (isFetching) return this.renderLoading();

        return (
            <MainContent>
                <PageHeader title={t("invoices.invoicesListPageTitle")} />
                <PageBody>
                    <div className="invoice-list__container">
                        <PoliciesAwarenessBanner clientId={user?.companyInfo?.id} />
                        {/* {daysToCoverEnd <= 45 &&
                            (getPaymentFrequency(selectedInvoice.payment_frequency_id) === 'Quarterly' ||
                                getPaymentFrequency(selectedInvoice.payment_frequency_id) === 'Biannually') && (
                                <NotificationBanner
                                    title="Plan Expiry"
                                    message={
                                        daysToCoverEnd <= 0
                                            ? t('invoices.insurancePlanExpiredMessage', {
                                                  expiryDate: selectedInvoice?.end_date,
                                                  comanyName: appConfig.companyName
                                              })
                                            : t('invoices.insurancePlanToExpireMessage', {
                                                  dayToExpiration: daysToCoverEnd,
                                                  expiryDate: selectedInvoice?.end_date,
                                                  comanyName: appConfig.companyName
                                              })
                                    }
                                    type={getCoverWarningType(daysToCoverEnd)}
                                    action={t("invoices.planExpiryActionButtonText")}
                                    path="/dashboard/plan-reactivation"
                                />
                            )} */}
                        <div className="invoice-list__wrapper">
                            <table className="dashboard__table">
                                <thead>
                                    <tr>
                                        <th>{t("invoices.invoicesListTableStatusColumn")}</th>
                                        <th>{t("invoices.invoicesListTableInvoiceCodeColumn")}</th>
                                        <th>{t("invoices.invoicesListTableDescriptionColumn")}</th>
                                        <th>{t("invoices.invoicesListTableAmountColumn")} ({appConfig.countryCurrency})</th>
                                        <th>{t("invoices.invoicesListTableDateIssuedColumn")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoices.map((invoice) => (
                                        <tr key={invoice.reference_code}>
                                            <td>
                                                {getInvoiceStatusIndicator(
                                                    invoice.payment_status_id,
                                                    t
                                                )}
                                            </td>
                                            <td>
                                                <Link
                                                    to={`/dashboard/invoices/${invoice.reference_code}`}
                                                    style={{display: 'block'}}
                                                >
                                                    {invoice.reference_code}
                                                </Link>
                                            </td>
                                            <td>{invoice.description}</td>
                                            <td>{t("common.amount", { amount: invoice.total_price })}</td>
                                            <td>
                                                {t('common.date', {
                                                    date: invoice.created_at,
                                                    formatParams: {
                                                        date: {
                                                            weekday: 'long',
                                                            year: 'numeric',
                                                            month: 'long',
                                                            day: 'numeric',
                                                        }
                                                    }
                                                })}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </PageBody>
            </MainContent>
        );
    }
}

const getInvoiceStatusIndicator = (status, t) => {
    if (status === 1) {
        return t("invoices.noPayment");
    } else if (status === 2) {
        return t("invoices.partialPayment");
    } else {
        return t("invoices.paymentComplete");
    }
};

const mapStateToProps = ({ invoice, session }) => ({
    isFetching: invoice.isFetching,
    invoices: invoice.invoices ? Immutable.asMutable(invoice.invoices) : [],
    error: invoice.error ? Immutable.asMutable(invoice.error) : {},
    alert: invoice.alert,
    user: session?.user
});

const InvoiceListComponentWithTranslation = withTranslation()(InvoiceListComponent);
export default withRouter(connect(mapStateToProps)(InvoiceListComponentWithTranslation));
